import * as dateYmd from '../date-ymd';
import * as timeHms from '../time-hms';
import moment from 'moment';
import {DISPLAYED_DATE_HM_FORMAT, DISPLAYED_DATE_HMS_FORMAT, STANDARD_DATE_TIME_FORMAT} from "../../constants/dateTime";

function stringToDateTime(str) {
    const parts = str.split(' ');
    const [Y, M, D] = dateYmd.stringToDate(parts[0]);
    const [h, m, s] = timeHms.stringToTime(parts[1]);

    return [Y, M, D, h, m, s];
}

function extractDate([Y, M, D, h, m, s]) {
    return [Y, M, D];
}

function extractTime([Y, M, D, h, m, s]) {
    return [h, m, s];
}

function extractDateFromString(str) {
    const [Y, M, D] = stringToDateTime(str);
    return [Y, M, D];
}

function extractTimeFromString(str) {
    const [Y, M, D, h, m, s] = stringToDateTime(str);
    return [h, m, s];
}

function dateTimeIsNull([Y, M, D, h, m, s], hasSeconds) {
    return dateYmd.dateIsNull([Y, M, D]) || timeHms.timeIsNull([h, m, s], hasSeconds);
}

function dateTimeToString([Y, M, D, h, m, s], hasSeconds) {
    if (dateTimeIsNull([Y, M, D, h, m, s], hasSeconds)) {
        return null;
    }

    return moment([Y, M - 1, D, h, m, hasSeconds ? s : 0]).format(STANDARD_DATE_TIME_FORMAT);
}

function dateTimeToDisplayedString([Y, M, D, h, m, s], hasSeconds) {
    if (dateTimeIsNull([Y, M, D, h, m, s], hasSeconds)) {
        return null;
    }

    return moment([Y, M - 1, D, h, m, hasSeconds ? s : 0]).format(hasSeconds ? DISPLAYED_DATE_HMS_FORMAT : DISPLAYED_DATE_HM_FORMAT);
}

function getNow() {
    const now = new Date();

    return [
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
    ];
}

function compareDateTimes([Y1, M1, D1, h1, m1, s1], [Y2, M2, D2, h2, m2, s2], hasSeconds) {
    const dateTime1Null = dateTimeIsNull([Y1, M1, D1, h1, m1, s1], hasSeconds);
    const dateTime2Null = dateTimeIsNull([Y2, M2, D2, h2, m2, s2], hasSeconds);

    if (dateTime1Null || dateTime2Null) {
        throw new Error('DateTimes to compare must be not null');
    }

    if (Y1 > Y2) return 1;
    if (Y1 < Y2) return -1;

    if (M1 > M2) return 1;
    if (M1 < M2) return -1;

    if (D1 > D2) return 1;
    if (D1 < D2) return -1;

    if (h1 > h2) return 1;
    if (h1 < h2) return -1;

    if (m1 > m2) return 1;
    if (m1 < m2) return -1;

    if (hasSeconds) {
        if (s1 > s2) return 1;
        if (s1 < s2) return -1;
    }

    return 0;
}

function getNullDateTime() {
    return [null, null, null, null, null, null];
}

export {
    stringToDateTime,
    extractDate,
    extractTime,
    extractDateFromString,
    extractTimeFromString,
    dateTimeToString,
    dateTimeToDisplayedString,
    dateTimeIsNull,
    getNow,
    compareDateTimes,
    getNullDateTime,
}
